const DEFAULT_TIMEOUT = 10000;

export async function apiFetch(url, options = {}) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), DEFAULT_TIMEOUT);

  try {
    const response = await fetch(url, {
      signal: controller.signal,
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      },
      ...options,
    });

    const isJson = response.headers
      .get('content-type')
      ?.includes('application/json');

    const data = isJson ? await response.json() : null;

    if (!response.ok) {
      throw new Error('Request failed');
    }

    return data;
  } finally {
    clearTimeout(timeout);
  }
}
